module.exports = __webpack_public_path__ + "static/media/wheel-gray.4303ad59.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/wheel-gray.png
// module id = 742
// module chunks = 0